import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { Spinner } from '../';
import './SearchBar.scss';

const SearchBar = ({
  outerCss,
  innerCss,
  name,
  placeholder,
  keyUpHandler,
  filtering,
  loading,
  searching,
}) => (
  <div className={`form-group ${outerCss}`} style={{ minHeight: 0 }}>
    <Input
      name={name}
      type="text"
      placeholder={placeholder}
      className={`${innerCss} form-control`}
      onKeyUp={e => keyUpHandler(e.target.value)}
    />
    {
    (filtering || (loading && searching)) ?
      <span className="search-spinner">
        <Spinner />
      </span>
      :
      null
    }
  </div>
);

SearchBar.defaultProps = {
  outerCss: 'm-0',
  innerCss: 'py-1 m-0 d-inline',
  keyUpHandler: () => {},
};

SearchBar.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  filtering: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  searching: PropTypes.bool.isRequired,
  outerCss: PropTypes.string,
  innerCss: PropTypes.string,
  keyUpHandler: PropTypes.func,
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.jsx